/**
  DOM utilities
============= **/

/* Disable a[href="#!"] links */
function disableEmptyLinks() {
	document.addEventListener('click', (e) => {
		if (e.target.matches('a[href="#!"]')) {
			e.preventDefault();
		}
	});
}

/* Disable CSS transitions until the window is fully loaded */
function disableTransitionsOnLoad() {
	window.addEventListener('load', () => {
		document.body.classList.remove('no-transitions');
	});
}

/* Disable CSS transitions during window resize */
function disableTransitionsOnResize(className = 'no-transitions', delay = 300) {
	const handleResize = debounce(() => {
		document.body.classList.remove(className);
	}, delay);

	window.addEventListener('resize', () => {
		document.body.classList.add(className);
		handleResize();
	});
}

export function applyInitialSettings() {
	disableEmptyLinks();
	disableTransitionsOnLoad();
	disableTransitionsOnResize();
}

/**
  General utilities
================= **/

/* Debounce a function to limit its execution rate */
export function debounce(func, delay) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), delay);
	};
}
